//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has , flatMap , map , filter } from 'lodash'
import * as ClassActivityActions from '../classActivities/actions';
import * as QuizActions from '../quizzes/actions';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create activity ----------------


//  -- Get activity -------------------

//  -- List activities ----------------
export const handleListActivities = () => async (dispatch) => {
    await dispatch(ActivityActions.listActivities());
    const ASSIGNMENT_LENGTH = 1000;
    try {
        const activities_count = await apis.get('activitiesRDS', `/list_activity_count`);
        if(activities_count>0){
            const arr_data = Array.apply(0, new Array(Math.floor(parseInt(activities_count) / ASSIGNMENT_LENGTH) + 1)).map((_k, i) => i)
            const all_activities = await Promise.allSettled(map(arr_data, async k => {
                const offset = k * ASSIGNMENT_LENGTH;
                const uniqueRequestId = `activity_offset${offset}_chunk${k}_limit${ASSIGNMENT_LENGTH}`;
                return  apis.get('activitiesRDS', `/get_activity_by_chunck/${offset}?requestId=${uniqueRequestId}`);
            })
            ).then(v => filter(v, ["status", "fulfilled"]).map(k => k.value))
            const allActivityData = flatMap(all_activities);
            if (Array.isArray(allActivityData) && allActivityData.length > 0) {
                await dispatch(ActivityActions.listActivitiesSuccess(allActivityData));
            }
            return allActivityData; 
        }
        // else{
        //     let activities = [];
        //     const activitiesRDS = await apis.get('activitiesRDS', `/activities`);
        //     if (Array.isArray(activitiesRDS) && activitiesRDS.length > 0) {
        //         activities = activitiesRDS
        //     }
        //     await dispatch(ActivityActions.listActivitiesSuccess(activities));
        //     return activities;
        // }
       
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing activities',
                error,
                module: 'ACTIVITIES',
                operation: 'LIST_ACTIVITIES'
            })
        }
        await dispatch(ActivityActions.listActivitiesFail(error));
    }
};


export const handleCreateActivities = (activity) => async (dispatch) => {
    dispatch(ActivityActions.createActivity())
    try {
        const activitiesRDS = await apis.post('activitiesRDS', `/create`, {
            body: activity
        });
        if (has(activitiesRDS, "id")) {
            await dispatch(ActivityActions.createActivitySuccess(activitiesRDS))
        } else {
            await dispatch(ActivityActions.createActivityFail(activitiesRDS))
        }
    } catch (error) {
        console.log(error, "error in create activities");
        logToSentry({
            message: 'Error creating activities',
            error,
            module: 'ACTIVITIES',
            operation: 'CREATE_ACTIVITY'
        })
    }
}
export const handleUpdateActivities = (id, activity) => async (dispatch) => {
    dispatch(ActivityActions.createActivity())
    try {
        const activitiesRDS = await apis.put('activitiesRDS', `/update/${id}`, {
            body: activity
        });
        if (has(activitiesRDS, "id")) {
            await dispatch(ActivityActions.updateActivitySuccess(activitiesRDS))
        } else {
            await dispatch(ActivityActions.updateActivityFail(activitiesRDS))
        }
    } catch (error) {
        logToSentry({
            message: 'Error updating activities',
            error,
            module: 'ACTIVITIES',
            operation: 'UPDATE_ACTIVITY'
        })
        console.log(error, "error in create activities");
    }
}


export const handleAdminDeleteActivities = (id) => async (dispatch) => {
    dispatch(ActivityActions.deleteActivity())
    try {
        const activitiesRDS = await apis.post('activitiesRDS', `/AdminActivityDelete`, {
            body: {
                "id": id,
            }
        });
        if (has(activitiesRDS, "id")) {
            await dispatch(ActivityActions.deleteActivitySuccess(activitiesRDS))
        }
    } catch (error) {
        logToSentry({
            message: 'Error deleting activities',
            error,
            module: 'ACTIVITIES',
            operation: 'DELETE_ACTIVITY'
        })
        console.log(error, "error in create activities");
    }
}

export const handleListCustomAssignment = (role,userId) => async dispatch =>{
    await dispatch(ActivityActions.listCustomAssignmentByUser())

    try {
        const assignments =  await apis.get('customAssignments',`/byUser/${role}/${userId}`);
        if(Array.isArray(assignments)){
            await dispatch(ActivityActions.listCustomAssignmentByUserSuccess(assignments))
        }
        return assignments;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'Error listing custom assignments',
                error,
                module: 'ACTIVITIES',
                operation: 'LIST_CUSTOM_ASSIGNMENTS'
            })
         }
        await dispatch(ActivityActions.listCustomAssignmentByUserFail(error));
    }
}

export const handleCreateCustomAssignment = (data) => async dispatch =>{
    await dispatch(ActivityActions.createCustomAssignment())

    try {
        const assignments =  await apis.post('customAssignments',`/create`,{
            body:data
        });
        if(has(assignments,"id")){
            await dispatch(ActivityActions.createCustomAssignmentSuccess(assignments))
        }
        return assignments;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'Error creating custom assignments',
                error,
                module: 'ACTIVITIES',
                operation: 'CREATE_CUSTOM_ASSIGNMENT'
            })
         }
        await dispatch(ActivityActions.createCustomAssignmentFail(error));
    }
}
export const handleCloneCustomAssignment = (page, chapter, assignment_id, created_by, label_position, copy_of, operation = null , role = null) => async dispatch => {
    await dispatch(ActivityActions.createCustomAssignment())

    try {
        const assignments = await apis.post('customAssignments', `/cloneAssignment`, {
            body: {
                "page": page,
                "chapter": chapter,
                "assignment_id": assignment_id,
                "created_by": created_by,
                "label_position": label_position,
                "copy_of": copy_of,
                "operation": operation,
                "role": role
            } 
        });
        if (has(assignments, "id")) {
            await dispatch(ActivityActions.createCustomAssignmentSuccess(assignments))
        }
        return assignments;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error cloning custom assignments',
                error,
                module: 'ACTIVITIES',
                operation: 'CLONE_CUSTOM_ASSIGNMENT'
            })
        }
        await dispatch(ActivityActions.createCustomAssignmentFail(error));
    }
}

export const handleCloneWorksheetAssignmentToPage =
  (page, chapter, worksheet_id, created_by, label_position, copy_of, operation = 'copy') => async () => {
    try {
      const op = operation === 'move' ? 'move' : 'copy';
      const body = {
        page: String(page),
        chapter: String(chapter),
        worksheet_id: String(worksheet_id),
        created_by,
        label_position,
        operation: op,
      };
      if (op === 'copy' && copy_of != null) {
        body.copy_of = copy_of;
      }
      const result = await apis.post('activitiesRDS', `/worksheet/cloneToPage`, {
        body,
      });
      return result;
    } catch (error) {
      if (error && error.message != 'Network Error') {
        logToSentry({
          message: 'Error cloning or moving worksheet assignment to page',
          error,
          module: 'ACTIVITIES',
          operation: 'CLONE_WORKSHEET_ASSIGNMENT_TO_PAGE',
        });
      }
      return { error: error?.message || 'request failed' };
    }
  };

export const handleAdminCopyOrMoveAssignment = (payload) => async (dispatch) => {
    try {
        const result = await apis.post('customAssignments', `/adminCopyMoveAssignment`, {
            body: {
                operation: payload.operation,
                typeId: payload.typeId,
                assignment_id: payload.assignment_id,
                chapter: String(payload.chapter),
                page: String(payload.page),
                bookId: payload.bookId != null ? String(payload.bookId) : String(payload.chapter),
                acting_user_id: payload.acting_user_id,
            },
        });
        if (result && result.error) {
            return result;
        }
        if (result && result.id) {
            if (payload.operation === 'move') {
                if (payload.typeId === 'quiz') {
                    dispatch(QuizActions.updateQuizSuccess(result));
                } else {
                    dispatch(ActivityActions.updateActivitySuccess(result));
                }
            } else if (payload.operation === 'copy') {
                if (payload.typeId === 'quiz') {
                    dispatch(QuizActions.createQuizSuccess(result));
                } else {
                    dispatch(ActivityActions.createActivitySuccess(result));
                }
            }
        }
        return result;
    } catch (error) {
        if (error && error.message != 'Network Error') {
            logToSentry({
                message: 'Error admin copy/move assignment',
                error,
                module: 'ACTIVITIES',
                operation: 'ADMIN_COPY_MOVE_ASSIGNMENT',
            });
        }
        return { error: error?.message || 'request failed' };
    }
};

export const handleAssignGraphicOrgToEbook = (page, chapter, assignment_id, created_by, displayName, colorCode) => async dispatch => {
    try {
        const assignments = await apis.post('customAssignments', `/graphic_organizer/create_assignment`, {
            body: {
                page,
                chapter,
                assignment_id,
                created_by,
                displayName,
                colorCode
            }
        });
        if (assignments && assignments.success&&assignments.data&&assignments.data.id) {
            await dispatch(handleListActivities())
        }
        return assignments;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error assigning graphic org to ebook',
                error,
                module: 'ACTIVITIES',
                operation: 'ASSIGN_GRAPHIC_ORG_TO_EBOOK'
            })
        }
    }
}
export const handleUpdateGraphicOrgToEbook = ( assignment_id , displayName, colorCode) => async dispatch => {
    try {
        const assignments = await apis.post('customAssignments', `/graphic_organizer/update_assignment`, {
            body: {
                assignment_id,
                displayName,
                colorCode
            }
        });
        if (assignments && assignments.success&&assignments.data&&assignments.data.id) {
            await dispatch(handleListActivities())
        }
        return assignments;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error updating graphic org to ebook',
                error,
                module: 'ACTIVITIES',
                operation: 'UPDATE_GRAPHIC_ORG_TO_EBOOK'
            })
        }
    }
}

export const handleUpdateCustomAssignment = (data, deleteClone,create_new_copy) => async dispatch =>{
    await dispatch(ActivityActions.updateCustomAssignment())

    try {
        const assignments =  await apis.put('customAssignments',`/update/${data.id}`,{
            body:data
        });
        if(has(assignments,"id")){
            if(deleteClone === 'deleteClone'){
                await dispatch(ActivityActions.deleteCustomAssignmentSuccess(assignments?.id))
                await dispatch(ClassActivityActions.deleteClassActivitySuccess({ id: assignments?.id}));
            }else if(create_new_copy){
                await dispatch(ActivityActions.createCustomAssignmentSuccess(assignments))
            }
             else {
                await dispatch(ActivityActions.updateCustomAssignmentSuccess(assignments))
            }
        }
        return assignments;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'Error updating custom assignments',
                error,
                module: 'ACTIVITIES',
                operation: 'UPDATE_CUSTOM_ASSIGNMENT'
            })
         }
        await dispatch(ActivityActions.updateCustomAssignmentFail(error));
    }
}
export const handleDeleteCustomAssignment = (id) => async dispatch =>{
    await dispatch(ActivityActions.deleteCustomAssignment())
    try {
        const assignments =  await apis.del('customAssignments',`/delete/${id}`);
        if(has(assignments,"id")){
            await dispatch(ActivityActions.deleteCustomAssignmentSuccess(id))
            await dispatch(ClassActivityActions.deleteClassActivitySuccess({ id }));
        }
        return assignments;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'Error deleting custom assignments',
                error,
                module: 'ACTIVITIES',
                operation: 'DELETE_CUSTOM_ASSIGNMENT'
            })
         }
        await dispatch(ActivityActions.deleteCustomAssignmentFail(error));
    }
}
export const handleUnhareToMe = (id, user_id) => async dispatch => {
    await dispatch(ActivityActions.deleteCustomAssignment())
    try {
        const assignments = await apis.post('customAssignments', `/unShareToMe`, {
            body: {
                id, user_id
            }
        });
        if (has(assignments, "id")) {
            await dispatch(ActivityActions.deleteCustomAssignmentSuccess(id))
            await dispatch(ClassActivityActions.deleteClassActivitySuccess({ id }));
        }
        return assignments;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error unsharing custom assignments',
                error,
                module: 'ACTIVITIES',
                operation: 'UNSHARE_CUSTOM_ASSIGNMENT'
            })
        }
        await dispatch(ActivityActions.deleteCustomAssignmentFail(error));
    }
}

export const handleGetAssignmentStatus = async (activityID,userId)=>{
    try {
        const statusData = await apis.get('activitiesRDS', `/getAssignedStatusByUser/${activityID}/${userId}`);
        return statusData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error getting assignment status',
                error,
                module: 'ACTIVITIES',
                operation: 'GET_ASSIGNMENT_STATUS'
            })
        }
        return []
    }
   
}

export const handleGetActivityById = async (activityID)=>{
    try {
        const statusData = await apis.get('activitiesRDS', `/listByIdActivities/${activityID}`);
        return statusData;
    } catch (error) {
        return []
    }
   
}





export const handleGetAssignmentAssignStatus = async (id) => {
    try {
        const assignments = await apis.get('customAssignments', `/assignment_ststus/${id}`);
        return assignments
    } catch (error) {
        return ({})
    }
}

//Worksheet
export const handleCreateWorksheetAssignment =(workSheetInfo,assignmentData,user_id)=> async (dispatch)=>{
    try {
        const statusData = await apis.post('activitiesRDS', `/worksheet/create`,{
            body:{
                 workSheetInfo, assignmentData, user_id 
            }
        });
        return statusData;
    } catch (error) {
        return []
    }
   
}
export const handleSubmitWorksheetAssignment =(data)=> async (dispatch)=>{
    try {
        const statusData = await apis.post('activitiesRDS', `/worksheet/submission`,{
            body:data
        });
        return statusData;
    } catch (error) {
        return []
    }
   
}

export const handleUpdateWorksheetSubmission =(data)=> async (dispatch)=>{
    try {
        const statusData = await apis.put('activitiesRDS', `/worksheet/updateSubmission`,{
            body:data
        });
        return statusData;
    } catch (error) {
        return []
    }
}

export const handleUpdateWorksheetAssignment =(assignmentData,user_id,id)=> async (dispatch)=>{
    try {
        const statusData = await apis.post('activitiesRDS', `/worksheet/update`,{
            body:{
                  assignmentData, user_id , id
            }
        });
        return statusData;
    } catch (error) {
        return []
    }
   
}
export const handleUpdateSequence = (data) => async (dispatch) => {
    try {
      await apis.post("activitiesRDS", `/updateActivitySequence`, {
        body: data,
      });
  
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error updating sequence',
                error,
                module: 'ACTIVITIES',
                operation: 'UPDATE_SEQUENCE'
            })
        }
    }
  };

 export const handleUpdateAndDeleteSubMission = (data) => async (dispatch) => {
  try {
    await apis.post('customAssignments', `/delete_assignment_submissions`, {
      body: data,
    });
  } catch (error) {
   logToSentry({
       message: 'Error in activities operation',
       error,
       module: 'ACTIVITIES',
       operation: 'LIST_ACTIVITIES'
   });
  }
};

export const handleListActivitiesByIds = (ids) => async (dispatch) => {
    try {
        const activities = await apis.post('activitiesRDS', `/list_admin_activities_by_books`, {
            body: {
                ids
            }
        });
        return activities;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing activities by ids',
                error,
                module: 'ACTIVITIES',
                operation: 'LIST_ACTIVITIES_BY_IDS'
            })
        }
        return [];
    }
}

export const handleListAssignedActivitiesByIds = (ids, classId) => async (dispatch) => {
    try {
        const activities = await apis.post('activitiesRDS', `/list_assigned_activites_admin`, {
            body: {
                ids,
                classId
            }
        });
        return activities;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing assigned activities by ids',
                error,
                module: 'ACTIVITIES',
                operation: 'LIST_ASSIGNED_ACTIVITIES_BY_IDS'
            })
        }
        return [];
    }
}

export const listResourseActivities = (ids) => async (dispatch) => {
    try {
        const activities = await apis.get('activitiesRDS', `/list_admin_resourse_activity`);
        return activities;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing resource activities',
                error,
                module: 'ACTIVITIES',
                operation: 'LIST_RESOURCE_ACTIVITIES'
            })
        }
        return [];
    }
}

export const handleCreateOwnGraphicOrganizer = (data) => async (dispatch) => {
    dispatch(ActivityActions.createOwnGraphicOrganizer());
    try {
        const response = await apis.post('activitiesRDS', `/createOwnGraphicOrganizer`, {
            body: data
        });
        if (response && response.error) {
            throw response.error;
        }

        const result = response.data || response;

        if (has(result, "id")) {
            await dispatch(ActivityActions.createOwnGraphicOrganizerSuccess(result));
            return { success: true, data: result };
        } else {
            await dispatch(ActivityActions.createOwnGraphicOrganizerFail(result));
            return { success: false, error: result };
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error creating own graphic organizer',
                error,
                module: 'ACTIVITIES',
                operation: 'CREATE_OWN_GRAPHIC_ORGANIZER'
            });
        }
        await dispatch(ActivityActions.createOwnGraphicOrganizerFail(error));
        return { success: false, error };
    }
}

export const handleUpdateOwnGraphicOrganizer = (id, data) => async (dispatch) => {
    dispatch(ActivityActions.updateOwnGraphicOrganizer());
    try {
        const response = await apis.put('activitiesRDS', `/updateOwnGraphicOrganizer/${id}`, {
            body: data
        });
        if (response && response.error) {
            throw response.error;
        }

        const result = response.data || response;
        if (has(result, "id")) {
            await dispatch(ActivityActions.updateOwnGraphicOrganizerSuccess(result));
            return { success: true, data: result };
        } else {
            await dispatch(ActivityActions.updateOwnGraphicOrganizerFail(result));
            return { success: false, error: result };
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error updating own graphic organizer',
                error,
                module: 'ACTIVITIES',
                operation: 'UPDATE_OWN_GRAPHIC_ORGANIZER'
            });
        }
        await dispatch(ActivityActions.updateOwnGraphicOrganizerFail(error));
        return { success: false, error };
    }
}

export const handleListOwnGraphicOrganizer = (userId) => async (dispatch) => {
    dispatch(ActivityActions.listOwnGraphicOrganizer());
    try {
        const response = await apis.get('activitiesRDS', `/listOwnGraphicOrganizer/${userId}`);
        
        if (response && response.error) {
            throw response.error;
        }

        const result = response.data || response;
        if (Array.isArray(result)) {
            await dispatch(ActivityActions.listOwnGraphicOrganizerSuccess(result));
            return { success: true, data: result };
        } else {
            await dispatch(ActivityActions.listOwnGraphicOrganizerFail(result));
            return { success: false, data: [] };
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing own graphic organizer',
                error,
                module: 'ACTIVITIES',
                operation: 'LIST_OWN_GRAPHIC_ORGANIZER'
            });
        }
        await dispatch(ActivityActions.listOwnGraphicOrganizerFail(error));
        return { success: false, data: [] };
    }
}

export const handleDeleteOwnGraphicOrganizer = (id) => async (dispatch) => {
    dispatch(ActivityActions.deleteOwnGraphicOrganizer());
    try {
        const response = await apis.del('activitiesRDS', `/deleteOwnGraphicOrganizer/${id}`);
        if (response && response.error) {
            throw response.error;
        }

        const result = response.data || response;
        if (has(result, "id")) {
            await dispatch(ActivityActions.deleteOwnGraphicOrganizerSuccess(id));
            return { success: true, data: result };
        } else {
            await dispatch(ActivityActions.deleteOwnGraphicOrganizerFail(result));
            return { success: false, error: result };
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error deleting own graphic organizer',
                error,
                module: 'ACTIVITIES',
                operation: 'DELETE_OWN_GRAPHIC_ORGANIZER'
            });
        }
        await dispatch(ActivityActions.deleteOwnGraphicOrganizerFail(error));
        return { success: false, error };
    }
}
export const handleAdminDeleteEnageActivity = (data) => async (dispatch) => {
    try {
        const activitiesRDS = await apis.post('activitiesRDS', `/deleteAllEnange`, {
            body: data
        });
        if(activitiesRDS?.data?.length > 0){
            await dispatch(ActivityActions.deleteEnageActivitySuccess(activitiesRDS?.data))
        }
        return activitiesRDS;
    } catch (error) {
        logToSentry({
            message: 'Error deleting activities',
            error,
            module: 'ACTIVITIES',
            operation: 'DELETE_ACTIVITY'
        })
        console.log(error, "error in create activities");
    }
}

export const handleAdminDeleteEnageActivitySequence = (data) => async (dispatch) => {
    try {
        const activitiesRDS = await apis.post('activitiesRDS', `/deleteParticularEnange`, {
            body: data
        });
        if(activitiesRDS?.data?.length > 0){
            await dispatch(ActivityActions.deleteEnageActivitySuccess(activitiesRDS?.data))
        }
        return activitiesRDS;
    } catch (error) {
        logToSentry({
            message: 'Error deleting activities',
            error,
            module: 'ACTIVITIES',
            operation: 'DELETE_ACTIVITY'
        })
        console.log(error, "error in create activities");
    }
}
//handle list activities by chapter 
export const handleListChapterActivities = (chapterId) => async (dispatch) => {
    try {
        const activities = await apis.get('activitiesRDS', `/activitiesByChapter/${chapterId}`);
        const list = Array.isArray(activities) ? activities : [];
        await dispatch(ActivityActions.listChapterActivitiesSuccess(list));
        return list;
    } catch (error) {
        return [];
    }
}

const normalizeShareList = (shareList) => {
    if (Array.isArray(shareList)) {
        return shareList;
    }
    if (typeof shareList === 'string') {
        try {
            const parsed = JSON.parse(shareList);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
    return [];
};

export const fetchShareListAssignment = ({ assignmentId, activityType, shareList } = {}) => async (dispatch, getState) => {
    const getLocalShareList = () => {
        let list = normalizeShareList(shareList);
        if (!list.length && assignmentId) {
            const worksheet = (getState()?.worksheetReducer || []).find((item) => item?.id === assignmentId);
            list = normalizeShareList(worksheet?.share_list);
        }
        return list;
    };

    try {
        const result = await apis.post('customAssignments', '/fetchShareListAssignment', {
            body: { assignmentId, activityType },
        });
        const list = normalizeShareList(
            result?.result?.share_list ?? result?.share_list ?? getLocalShareList(),
        );
        await dispatch(ActivityActions.listShareListSuccess(list));
    } catch (error) {
        if (error && error.message !== 'Network Error') {
            logToSentry({
                message: 'Error fetching assignment share list',
                error,
                module: 'ACTIVITIES',
                operation: 'FETCH_SHARE_LIST_ASSIGNMENT',
            });
        }
        await dispatch(ActivityActions.listShareListSuccess(getLocalShareList()));
    }
};